module.exports = __webpack_public_path__ + "static/img/ic_bale.4de6b53.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ic_bale.png
// module id = 1027
// module chunks = 1